module.exports = __webpack_public_path__ + "7556f0df.svg";